import Vue from 'vue';
import Router from 'vue-router';
import home from './home';
const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router);
export function createRouter () {
  return new Router({
    mode: 'history', // 注意这里也是为history模式
    routes: [].concat(
      home,
    ),
  });
}



// WEBPACK FOOTER //
// ./src/router/index.js